import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_BOTS: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch agents.'),
      403: i18n.t('You are not allowed to fetch agents.'),
      404: i18n.t('The agents you are trying to fetch do not exist.'),
      500: i18n.t('There was an error fetching agents.'),
      default: i18n.t('An error occurred fetching agents.')
    }
  },
  FETCH_BOT: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch agent.'),
      403: i18n.t('You are not allowed to fetch agent.'),
      404: i18n.t('The agent you are trying to fetch does not exist.'),
      500: i18n.t('There was an error fetching agent.'),
      default: i18n.t('An error occurred fetching agent.')
    }
  },

  FETCH_BOT_DEFAULT_PROMPT: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch agent default prompt.'),
      403: i18n.t('You are not allowed to fetch agent default prompt.'),
      404: i18n.t('The agent default prompt you are trying to fetch does not exist.'),
      500: i18n.t('There was an error fetching agent default prompt.'),
      default: i18n.t('An error occurred fetching agent default prompt.')
    }
  },

  FETCH_BOT_PUBLIC: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch agent.'),
      403: i18n.t('You are not allowed to fetch agent.'),
      404: i18n.t('The agent you are trying to fetch does not exist.'),
      500: i18n.t('There was an error fetching agent.'),
      default: i18n.t('An error occurred fetching agent.')
    }
  },

  CREATE_BOT: {
    ERROR: {
      401: i18n.t('You are not authorized to create the agent.'),
      403: i18n.t('You are not allowed to create the agent.'),
      404: i18n.t('The agent you are trying to create does not exist.'),
      500: i18n.t('There was an error creating the agent.'),
      default: i18n.t('An error occurred creating the agent.')
    },
    SUCCESS: {
      200: i18n.t('Agent created successfully.')
    }
  },

  UPDATE_BOT: {
    ERROR: {
      401: i18n.t('You are not authorized to update agent configuration.'),
      403: i18n.t('You are not allowed to update agent configuration.'),
      404: i18n.t('The agent you are trying to update does not exist.'),
      500: i18n.t('There was an error updating the agent configuration.'),
      default: i18n.t('An error occurred updating the agent configuration.')
    },
    SUCCESS: {
      200: i18n.t('Agent configuration updated.')
    }
  },

  DELETE_BOT: {
    ERROR: {
      401: i18n.t('You are not authorized to delete the agent.'),
      403: i18n.t('You are not allowed to delete the agent.'),
      404: i18n.t('The agent you are trying to delete does not exist.'),
      500: i18n.t('There was an error deleting the agent.'),
      default: i18n.t('An error occurred deleting the agent.')
    },
    SUCCESS: {
      200: i18n.t('Agent deleted successfully.')
    }
  },

  CLONE_BOT: {
    ERROR: {
      401: i18n.t('You are not authorized to clone agent.'),
      403: i18n.t('You are not allowed to clone agent.'),
      404: i18n.t('The agent you are trying to clone does not exist.'),
      500: i18n.t('There was an error cloning agent.'),
      default: i18n.t('An error occurred cloning the agent.')
    },
    SUCCESS: {
      200: i18n.t('Agent cloned successfully.')
    }
  },

  TRAIN_BOT: {
    ERROR: {
      401: i18n.t('You are not authorized to train this agent.'),
      403: i18n.t('You are not allowed to train this agent.'),
      404: i18n.t('The agent you are trying to train does not exist.'),
      500: i18n.t('There was an error starting the NLP training.'),
      default: i18n.t('An error occurred starting the NLP training.')
    },
    SUCCESS: {
      200: i18n.t('NLP training started.')
    }
  },

  UPDATE_LIVECHAT_SETTINGS: {
    ERROR: {
      401: i18n.t('You are not authorized to update LiveChat settings.'),
      403: i18n.t('You are not allowed to update LiveChat settings.'),
      404: i18n.t('The agent you are trying to update LiveChat settings does not exist.'),
      500: i18n.t('There was an error updating LiveChat settings.'),
      default: i18n.t('An error occurred updating LiveChat settings.')
    },
    SUCCESS: {
      200: i18n.t('LiveChat settings updated successfully.')
    }
  },

  CLEAR_CACHE: {
    ERROR: {
      401: i18n.t('You are not authorized to clear the agent cache.'),
      403: i18n.t('You are not allowed to clear the agent cache.'),
      404: i18n.t('The agent you are trying to clear the cache does not exist.'),
      500: i18n.t('There was an error clearing the agent cache.'),
      default: i18n.t('An error occurred clearing the agent cache.')
    },
    SUCCESS: {
      200: i18n.t('Agent cache reset successfully.')
    }
  },

  PROCESS_MESSAGE: {
    ERROR: {
      401: i18n.t('You are not authorized to process this message.'),
      403: i18n.t('You are not allowed to process this message.'),
      404: i18n.t('The message you are trying to process does not exist.'),
      500: i18n.t('An error occurred processing the message.'),
      default: i18n.t('An error occurred processing the message.')
    },
    SUCCESS: {
      200: i18n.t('Message processed successfully.')
    }
  }
};
